import { api } from "../../axios";

export const actions = {

    //COA Email
    GetEmail(context, data){
        return api.get(`Settings/CoaEmail/${data}`);
    },
    UpdateEmail(context, data){
        return api.put(`Settings/CoaEmail/${data.campusId}`, data);
    },
    CreateEmail(context, data){
        return api.post(`Settings/Create/Coa/Email/${data.campusId}`, data);
    },

}